import React from 'react';
import { Link } from 'react-router-dom';

export const Subnav = props => {
  return (
    <div className="Subnav">
      <ul className="Subnav__breadcrumb">
        <li className="home">
          <Link to={`/licenses`}>
            <i className="fa fa-home"></i>
          </Link>
        </li>
      </ul>
      {props.isPayer ? (
        <ul className="Subnav__admin">
          <li className="Subnav__update-payment">
            <Link to="/payment-info">Update Payment Info</Link>
          </li>
        </ul>
      ) : null}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/subnav/index.js